import React from 'react';

import { useMediaQuery } from '@mui/material';
import { Box } from '@provider-portal/design-common/kalep/components/Box/Box';
import { Button } from '@provider-portal/design-common/kalep/components/Button/Button';
import { Typography } from '@provider-portal/design-common/kalep/components/Typography/Typography';
import { theme } from '@provider-portal/design-common/kalep/theme/styles/themeMui';

import { ChevronRight } from '@bolteu/kalep-react-icons';

export interface StoreSelectorCurrentStoreProps {
  isOpen: boolean;
  parentName: string;
  storeName: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

export function StoreSelectorCurrentStore({
  isOpen,
  parentName,
  storeName,
  onClick,
}: StoreSelectorCurrentStoreProps) {
  const isMd = useMediaQuery(theme.breakpoints.down('md'));
  const handelArrowClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick(event);
    },
    [onClick],
  );

  const typographyStyles = React.useMemo(() => {
    return {
      width: '100%',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      lineHeight: '16px',
      ...(!isMd && { textAlign: 'left' }),
    };
  }, [isMd]);

  return (
    <Button
      id="store-selector-button"
      onClick={handelArrowClick}
      color="static-light"
      aria-controls={isOpen ? 'store-menu' : undefined}
      aria-haspopup="true"
      aria-expanded={isOpen ? 'true' : undefined}
      sx={{
        ...(!isMd && {
          width: '100%',
          justifyContent: 'space-between!important',
        }),
        display: 'flex',
        alignItems: 'center',
        p: { sm: '4px 8px', md: '12px' },
        borderRadius: '8px!important',
        '&:hover': {
          backgroundColor: (t) => `${t.palette.colors.bg['neutral-secondary']}!important`,
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        flex="1"
        minWidth={0}
        maxWidth={!isMd ? '90%' : undefined}
        alignItems="stretch"
        width={!isMd ? '100%' : undefined}
      >
        {!isMd ? (
          <Box sx={typographyStyles}>
            <Typography variant="body-m-accent">{parentName}</Typography>
          </Box>
        ) : null}
        <Box sx={typographyStyles}>
          <Typography
            variant={!isMd ? 'body-xs-regular' : 'body-s-regular'}
            color={!isMd ? 'secondary' : 'primary'}
          >
            {storeName}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          color: (t) => t.palette.colors.content.secondary,
          width: '18px',
          height: '18px',
          '& svg': {
            width: '18px',
            height: '18px',
            aspectRatio: '1/1',
            transform: 'rotate(90deg)',
          },
        }}
      >
        <ChevronRight />
      </Box>
    </Button>
  );
}
